<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="mTitle" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div class="p-t-8">
                    Apakah <b>Aplikasi Whatsapp yang ada gunakan sudah update yang terbaru ? </b>

<!--                    klik menu halaman perangkat tertaut (Linked Device) di app WA Anda, apakah terdapat gambar seperti ini dan mendukung multi perangkat?-->
<!--                    <div style="text-align: center;">-->
<!--                        <img-->
<!--                            src="@/assets/img/whatsapp_linked_multiple.png"-->
<!--                            alt="" class="img-whatsapp-multi">-->
<!--                    </div>-->
                    <div class="m-t-4 m-d-8" style="background: #F2F5F7; border-radius: 8px; padding: 8px 12px;">
                        <p class="f-14 f-bold f-c-midgrey m-d-0">
                            Harap diperhatikan:
                        </p>
                        <ul class="p-l-20 f-regular f-14 f-c-midgrey">
                            <li>
                                Untuk Perangkat Android, Aplikasi Whatsapp Minimal versi 2.22.7.74 ke atas.
                            </li>
                            <li>
                                Untuk Perangkat iOS, Aplikasi Whatsapp Minimal versi 2.22.4.75 ke atas.
                            </li>
                            <li>
                                Ciri - ciri app terbaru, mendukung login whatsapp web di lebih dari 1 perangkat (Multiperangkat).
                            </li>
                        </ul>
                    </div>

                    <div>

                    </div>
                </div>
            </template>
            <template v-slot:modal-footer>
                <div>
                    <div style="margin-bottom: 10px">
                        <SOButton
                                :primary="true"
                                :full="true"
                                :text="'Iya, Sudah Update Yang Terbaru'"
                                :id="'confirm-resend'"
                                @action="onConfirmNew"
                        />
                    </div>
                    <div>
                        <SOButton
                                :outline="true"
                                :full="true"
                                :text="'Belum, Masih memakai versi lama'"
                                :id="'batal-confirm-resend'"
                                @action="onConfirmOld"
                        />
                    </div>
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from "vuex";

    import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
    import SOButton from "@/so-components/global/ui/SOButton";
    import resulter from "@/store/utils/resulter";

    import { moduleName } from "../../store/state";

    export default {
        name: "ConfirmWAMultiple",
        components: {
            SOSlotModal,
            SOButton,
        },
        data() {
            return {
                backLink: "wa_autosender.connect_perangkat",
                modalId: "modal-confirm-wa-multi",
            };
        },
 /*       beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.setBackLink(from.name);
            });
        },
        beforeRouteLeave(to, from, next) {
            this.closeModal();
            next();
        },
*/        mounted() {
            $(`#${this.modalId}`).modal("show");
        },
        computed: {
            mTitle() {
                return `Konfirmasi Versi Aplikasi Whatsapp anda`;
            },
            getIdDevice() {
                return this.$route.params.id_device;
            },
            getNumber() {
                return this.customer.number;
            },
            getVia(){
                return this.$route.query.via
            },

        },
        methods: {
            async back() {
                await this.$router.push({ name: this.backLink});
            },
            closeModal() {
                $(`#${this.modalId}`).modal("hide");
            },
            setBackLink(val) {
                this.backLink = val;
            },
            onConfirmNew() {
                let query = {
                    multiperangkat: 1,
                    autogenerate: 1,
                    onsite:2,
                };
                let routerGenerate = "wa_autosender.connect_perangkat.off_site";
                if(this.getVia==="website"){
                    query.readonly= this.$route.query.readonly
                     routerGenerate = "wa_autosender.connect_perangkat.web_site";

                }
                this.$router.push({
                    name: routerGenerate,
                    query
                });
            },
            onConfirmOld() {
                this.$toast.error("Lakukan update aplikasi whatsapp yang terbaru di perangkat anda, kemudian scan ulang lagi.");
                if(this.getVia==="website"){
                    let query = {
                        multiperangkat: 1,
                        autogenerate: 0,
                        onsite:1,
                        needUpdateWA:"yes",
                        readonly:this.$route.query.readonly
                    };

                    let routerGenerate = "wa_autosender.connect_perangkat.web_site";
                    this.$router.push({
                        name: routerGenerate,
                        query
                    });

                }else{
                    this.$router.push({ name: this.backLink});
                }
            },
        },
    };
</script>

<style scoped>
    .img-whatsapp-multi{
        max-width: 300px;
    }
</style>
